module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transcollect"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("交易管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("交易汇总")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel down",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("交易时间")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "editable": false,
      "placeholder": "选择日期范围",
      "size": "small",
      "clearable": false
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "choosetime"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.form.choosetime),
      callback: function($$v) {
        _vm.$set(_vm.form, "choosetime", $$v)
      },
      expression: "form.choosetime"
    }
  }, _vm._l((_vm.choosetimes), function(item) {
    return _c('el-radio-button', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [(!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("门店分组")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fenzuid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.getShopList(_vm.form.fenzuid)
      }
    },
    model: {
      value: (_vm.form.fenzuid),
      callback: function($$v) {
        _vm.$set(_vm.form, "fenzuid", $$v)
      },
      expression: "form.fenzuid"
    }
  }, _vm._l((_vm.grouplist), function(group) {
    return _c('el-option', {
      key: group.group_id,
      attrs: {
        "label": group.group_name,
        "value": group.group_id
      }
    })
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc panel-select__desc2"
  }, [_vm._v("门店")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selectShopUid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.getOperators(_vm.form.selectShopUid)
      }
    },
    model: {
      value: (_vm.form.selectShopUid),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectShopUid", $$v)
      },
      expression: "form.selectShopUid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("操作账号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "operaValue"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small",
      "disabled": _vm.form.selectShopUid === ''
    },
    on: {
      "change": _vm.operaChange
    },
    model: {
      value: (_vm.form.operaValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "operaValue", $$v)
      },
      expression: "form.operaValue"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "门店主账户",
      "value": "vl"
    }
  }), _vm._v(" "), _vm._l((_vm.operaList), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  })], 2)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group down-btn"
  }, [_c('div', {
    staticClass: "panel-select-down-btn",
    on: {
      "click": function($event) {
        _vm.changePullStatus()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.pullflag ? '收起' : '展开'))]), _vm._v(" "), _c('i', {
    staticClass: "icon-right_arrow",
    class: {
      'icon-down_arrow__rotate': _vm.pullflag
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collpase"
    }
  }, [(_vm.pullflag) ? _c('div', {
    staticClass: "collpase"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("交易方式")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll1"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange1
    },
    model: {
      value: (_vm.form.checkAll1),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll1", $$v)
      },
      expression: "form.checkAll1"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "type"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange1
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("交易类型")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll2"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange2
    },
    model: {
      value: (_vm.form.checkAll2),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll2", $$v)
      },
      expression: "form.checkAll2"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "other"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange2
    },
    model: {
      value: (_vm.form.other),
      callback: function($$v) {
        _vm.$set(_vm.form, "other", $$v)
      },
      expression: "form.other"
    }
  }, _vm._l((_vm.otherList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select-group-btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group-btn",
    staticStyle: {
      "padding-left": "70px"
    }
  }, [_c('div', {
    staticClass: "panel-header-btn",
    on: {
      "click": _vm.search
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("查询")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn"
  }, [_c('a', {
    staticStyle: {
      "color": "#FE9B20",
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "href": _vm.collectHref,
      "download": ""
    }
  }, [_vm._v("导出")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-btn-group__wrapper panel-body-btn-group flex-normal"
  }, [_c('div', {
    staticClass: "num_total"
  }, [_c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("订单金额")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.sucamt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("交易金额")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.total_txamt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("手续费")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.total_fee)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("结算金额")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.settle_amt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("支付笔数")]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm.transData.sucnum || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper"
  }, [_c('p', {
    staticClass: "num-title"
  }, [_vm._v("退款笔数")]), _vm._v(" "), _c('p', {
    staticClass: "num-default"
  }, [_vm._v(_vm._s(_vm.transData.cancelnum || 0))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 10px 0px",
      "background-color": "#fff"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.transData.data,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "min-width": "140",
      "label": "交易时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.date))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "label": "交易方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.busicd_info))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transtype",
      "label": "交易类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-content"
        }, [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.total_amt)) + _vm._s(_vm.role.currency))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-content"
        }, [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.txamt)) + _vm._s(_vm.role.currency))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "支付笔数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.sucnum))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "退款笔数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cancel_num))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手续费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.total_fee)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.settle_amt)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix el-button--text",
          on: {
            "click": function($event) {
              _vm.goDetail(scope.row.date)
            }
          }
        }, [_vm._v("查询明细")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), (_vm.transData.num >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.transData.num,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder",
    staticStyle: {
      "background-color": "#fff"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dee1faaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transcollect/transcollect.vue
// module id = 839
// module chunks = 1